// extracted by mini-css-extract-plugin
export default {"div_with_timer":"InputTimerField_div_with_timer__zwZWU","border_red":"InputTimerField_border_red__yAwY4","mb_10":"InputTimerField_mb_10__vjr22"};